export enum CustomerSalesProductPaymentStatus {
  New = "N",
  BillingSent = "B",
  Paid = "P",
  Cancelled = "C",
  Delayed = "D",
}
